module.exports = __webpack_public_path__ + "img/9631f39b91b22a0b913a7a2ee25cd44c.png";